import { S2T_API_URL } from "@/config";

// Thin client for the EXISTING Source2Table production API.
// Read-only GETs for pricing/categories/legal; POSTs hit the real public
// Join endpoints that write to the existing production database.
const base = S2T_API_URL;

async function getJSON(path) {
  const res = await fetch(`${base}${path}`, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error(`GET ${path} failed (${res.status})`);
  return res.json();
}

async function postJSON(path, body) {
  const res = await fetch(`${base}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch (e) {
    data = {};
  }
  if (!res.ok) {
    const msg =
      (typeof data?.detail === "string" && data.detail) ||
      (Array.isArray(data?.detail) && data.detail[0]?.msg) ||
      "Something went wrong. Please try again.";
    throw new Error(msg);
  }
  return data;
}

export const getPricing = () => getJSON("/api/pricing");
export const getCategories = () => getJSON("/api/categories");
export const getLegalCurrent = () => getJSON("/api/legal/current");

// POST /api/join/notify-consumer  { email, source }
export const notifyConsumer = (payload) =>
  postJSON("/api/join/notify-consumer", payload);

// POST /api/join/producer  (JoinProducerRequest)
export const joinProducer = (payload) => postJSON("/api/join/producer", payload);
